export const dashboard = {
  chat: {
    title: "Chat",
    description: "Access our Chat playground to test a variety of LLM models.",
    button: "Basic Chat",
    button2: "Compare Chat",
    chatInterface: "Chat Interface",
    basicChat: "Basic Chat",
    compareChat: "Compare Chat",
  },
  credits: {
    title: "Payments and Usage",
    description: "Manage your credit purchases.",
    addCredits: "Add Balance",
    viewPayments: "View Payments",
    viewUsage: "Usage Details",
  },
  character: {
    title: "Characters",
    description:
      "Create and personalize AI characters for specialized interactions.",
    newCharacter: "New Character",
    viewCharacters: "View Characters",
  },
  agent: {
    title: "Agents",
    description:
      "Configure and deploy AI agents for customized tasks and workflows.",
    viewAgents: "View Agents",
    newAgent: "New Agent",
  },
  users: {
    title: "Users",
    description: "Manage sub-user accounts that can use your Agents.",
    viewUsers: "View Users",
    newUser: "New User",
  },
  settings: {
    title: "Settings and Account",
    description: "Manage your account, profile, API key settings.",
    settings: "Settings",
    profile: "Profile",
    affiliate: "Affiliate Program",
  },
  community: {
    title: "Community",
    description: "Request features or chat nerdy in Discord.",
    viewFeatures: "Features Board",
    viewDiscord: "Discord",
  },
  support: {
    title: "Support",
    description: "Request support or contact us.",
    viewSupport: "Customer Support",
    viewContact: "Contact",
  },
};
